import { cva } from 'class-variance-authority'

export const currencyAmountVariants = cva(
  'whitespace-nowrap text-base font-normal tabular-nums flex items-center justify-center',
  {
    variants: {
      size: {
        small: 'text-sm leading-5 h-5',
        base: 'text-base leading-6 h-6',
      },
      direction: {
        inflow: 'text-green-600',
        outflow: 'text-primary',
        neutral: 'text-primary',
      },
    },
    defaultVariants: {
      size: 'base',
      direction: 'neutral',
    },
  },
)
